/* Gout advertorial: post-offer links, pre-offer tap cards, Clarity tags (CRO 2026-10-02).
   Loaded once per page by sections/radiancy-adv-article.liquid (next to the H1). Plain ES5 + event delegation:
   works in the Facebook in-app browser, no exotic APIs.
   Clarity (app embed, window.clarity): every call is guarded with `window.clarity &&`.
     adv_tap_<slot>        a post-offer link was tapped, or a tap card was opened
     adv_card_keep_<slot>  card primary button      adv_card_skip_<slot>  card small link
     set utm_content / utm_term on load when they are in the URL.
   Link href + utm/fbclid carry-over is done by the layout's a[data-adv-pass-query] handler, not here. */
(function () {
  if (window.__advLinks) return;
  window.__advLinks = true;

  function ev(name) {
    try { window.clarity && window.clarity('event', name); } catch (e) {}
  }

  // utm_content / utm_term -> Clarity custom tags
  try {
    var q = new URLSearchParams(location.search);
    ['utm_content', 'utm_term'].forEach(function (k) {
      var v = q.get(k);
      if (v) { try { window.clarity && window.clarity('set', k, v); } catch (e) {} }
    });
  } catch (e) {}

  function setCard(card, open) {
    var fig = card.parentNode;
    var toggle = fig && fig.querySelector('[data-adv-card-toggle]');
    if (open) card.removeAttribute('hidden'); else card.setAttribute('hidden', '');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function scrollTo(id) {
    var el = id && document.getElementById(id);
    if (!el) return;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' }); }
    catch (e) { el.scrollIntoView(true); }
    try { el.focus({ preventScroll: true }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var go = t.closest('[data-adv-card-go]');
    if (go) {
      var card = go.closest('[data-adv-card]');
      var slot = card ? card.getAttribute('data-adv-card') : '';
      var id = (go.getAttribute('href') || '').replace(/^#/, '');
      e.preventDefault();
      ev('adv_card_' + go.getAttribute('data-adv-card-go') + '_' + slot);
      if (card) setCard(card, false);
      scrollTo(id);
      return;
    }

    var tog = t.closest('[data-adv-card-toggle]');
    if (tog) {
      var c = document.getElementById(tog.getAttribute('aria-controls'));
      if (!c) return;
      var opening = c.hasAttribute('hidden');
      setCard(c, opening);
      if (opening) ev('adv_tap_' + tog.getAttribute('data-adv-card-toggle'));
      return;
    }

    var link = t.closest('a[data-adv-tap]');
    if (link) ev('adv_tap_' + link.getAttribute('data-adv-tap'));
  });
})();
